import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { AIConversation } from '../../extViewmodels/sdk/models/AI';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = `aiconversation/filter`;

type QueryParams = {
	impersonationContext?: Api.IImpersonationContext;
	filter?: Api.AIConversationFilter;
	enabled?: boolean;
};

export function getAIConversationFilterQueryKey(queryParams: QueryParams): any[] {
	return [BASE_QUERY_KEY, queryParams.filter, queryParams.impersonationContext];
}

export function useAIConversationFilterQuery(queryParams: QueryParams) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: getAIConversationFilterQueryKey(queryParams),
		queryFn: () =>
			userSession.webServiceHelper.callAsync<AIConversation[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `aiconversation/filter`,
					impersonationContext: queryParams.impersonationContext,
				}),
				'POST',
				queryParams.filter
			),
		enabled: queryParams.enabled ?? true,
	});
}

export const invalidateAllAIConversationFilterQueries = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
};
